(function () {
  "use strict";

  function levelOf(el) {
    return parseInt(el.getAttribute("data-level"), 10) || 0;
  }

  function collapse(scope) {
    scope.querySelectorAll("[data-mega-menu-trigger]").forEach(function (trigger) {
      trigger.setAttribute("aria-expanded", "false");
    });
  }

  function reset(nav) {
    nav.querySelectorAll("[data-mega-menu-panel]").forEach(function (panel) {
      panel.hidden = true;
    });
    collapse(nav);
  }

  // The meganav is injected on first interaction, so we attach the close
  // observer lazily the first time a nav is used (when it is guaranteed present).
  function ensureCloseObserver(nav) {
    var meganav = nav.closest("[data-submenu]");
    if (!meganav || meganav.mmCloseObserved) return;
    meganav.mmCloseObserved = true;

    new MutationObserver(function () {
      if (!meganav.classList.contains("active")) reset(nav);
    }).observe(meganav, {
      attributes: true,
      attributeFilter: ["class", "aria-hidden"],
    });
  }

  function activate(trigger) {
    var nav = trigger.closest(".custom-mega-menu-nav");
    if (!nav) return;
    ensureCloseObserver(nav);

    var column = trigger.closest("[data-level]");
    var level = levelOf(column);

    var id = trigger.getAttribute("aria-controls");
    var selector = window.CSS && CSS.escape ? "#" + CSS.escape(id) : "#" + id;
    var target = id ? nav.querySelector(selector) : null;

    collapse(column);
    trigger.setAttribute("aria-expanded", "true");

    nav.querySelectorAll("[data-mega-menu-panel]").forEach(function (panel) {
      if (levelOf(panel) > level) {
        panel.hidden = true;
        collapse(panel);
      }
    });

    if (target) target.hidden = false;
  }

  document.addEventListener("click", function (evt) {
    var trigger = evt.target.closest("[data-mega-menu-trigger]");
    if (trigger) activate(trigger);
  });

  document.addEventListener("keydown", function (evt) {
    if (evt.repeat) return;
    if (evt.key !== " " && evt.key !== "Spacebar") return;
    var trigger = evt.target.closest("[data-meganav-trigger]");
    if (!trigger) return;
    evt.preventDefault();
    trigger.click();
  });
})();
